/**
 * Session Controller
 * Defines the interface for our Sessions Object
 */

// Import API singleton and appropriate resource interface
import api, { resolveWithStatus } from "@/services/api/api";
import { Session } from "@/interfaces";

// Define all of your actions
const create = async (body: Session, accessToken: any): Promise<any> => {
  try {
    const response = await api.post("/sessions", body, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });

    return response;
  } catch (error) {
    throw error;
  }
};

const index = async (accessToken: any): Promise<any> => {
  try {
    const sessions = (
      await api.get("/sessions", {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
    ).data;

    return sessions;
  } catch (error) {
    throw error;
  }
};

const show = async (roverID: string, accessToken: any): Promise<any> => {
  try {
    const response = await api.get(`/sessions/${roverID}/`, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });

    const sessionInformation = response.data;

    return sessionInformation;
  } catch (error) {
    throw error;
  }
};

const showMostRecent = async (
  sessionID: string,
  accessToken: any
): Promise<any> => {
  try {
    const session = (
      await api.get(`/sessions/${sessionID}/most-recent`, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
    ).data;

    return session;
  } catch (error) {
    throw error;
  }
};

const updateSessionStart = async (
  roverID: string,
  accessToken: any
): Promise<any> => {
  try {
    await api.put(
      `/sessions/start-date/${roverID}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      }
    );

    return;
  } catch (error) {
    throw error;
  }
};

// Then export all the actions
export default {
  create,
  index,
  show,
  showMostRecent,
  updateSessionStart
};
